import React from 'react';
import authProvider from '../../utilities/authProvider';
import { Information } from './common';
import { INTEGRATE_USER_SUCCESS_TITLE } from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';

export const LogoutUserIntegrateModal = ({ visible, multilineText = true }) => {
  const getMessage = () => {
    return (
      'アカウントの統合が完了しました。\n' +
      'ユーザーID（メールアドレス）をしたため自動的にログアウトします。\n' +
      '統合したID（メールアドレス）とパスワードを入力して再度ログインしてください。'
    );
  };

  return (
    <Information
      rootClassName='logout-user-integrate'
      visible={visible}
      message={getMessage()}
      title={INTEGRATE_USER_SUCCESS_TITLE}
      multilineText={multilineText}
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={() => authProvider.instance.logout()}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/LogoutUserIntegrateModal.jsx